import styled, { css } from 'styled-components';
import { fillAbsolute, objectFitEdge } from '../../../theme/mixins';
import { LazyLoadImage } from '../lazyLoadImage';

export const Container = styled.div`
  position: relative;
`;

export const Video = styled.video`
  ${objectFitEdge};
  object-fit: cover;

  transition: opacity 0.3s ease-in-out;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
`;

export const Image = styled(LazyLoadImage).attrs(() => ({
  placeholderStyle: css`
    ${fillAbsolute};
  `,
  imgStyle: css`
    object-fit: cover;
    width: 100%;
    height: 100%;
  `,
}))`
  ${fillAbsolute};
`;
